import { Calculation } from "@/models/Calculation";
import { InvoiceData } from "@/types";
import { OrderLineTypeUtils } from "@/types/order-line-type";

const mergeInvoiceDataAndCalculations = (
  invoiceData: InvoiceData[],
  calculations: Calculation[]
): InvoiceData[] => {
  return invoiceData.map((data: InvoiceData) => {
    const { nhoNumber, orderLineType } = data;

    const matchingCalc = calculations
      .filter(
        (c) =>
          c.nhoNumber === nhoNumber &&
          c.calculationType ===
            OrderLineTypeUtils.toCalculationType(orderLineType)
      )
      .shift();

    if (matchingCalc === undefined)
      return {
        ...data,
        isActive: true,
      };

    return {
      ...data,
      isActive: matchingCalc.isActive,
    };
  });
};

export default mergeInvoiceDataAndCalculations;
